import * as React from "react";
import { TimePickerCSSStyle } from "./timepickercss";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import './timepicker.css';
// import "react-datepicker/dist/react-datepicker.css";

export interface TimePickerItemProps
{
    label: string;
    hint: string;
    contentType: string;
    value: any;
    isRequired: boolean;
    style:TimePickerCSSStyle;
    disabled:boolean;
    autocomplete:string;
    errorMessage?:string;
    onChange?(value:any):void;
    onKeyPress?(e:React.KeyboardEvent):void;
    
}

export interface TimePickerItemState{
    value: any;
}

export class TimePickerItem extends React.Component<TimePickerItemProps, TimePickerItemState>{
    
    
    
    onChange:Function = ()=>{};
    constructor(props: TimePickerItemProps){
        super(props);
        
        this.state = {value:this.props.value};
        
        if(this.props.onChange !== undefined){
            this.onChange = this.props.onChange;
        }
        this.onType = this.onType.bind(this);
    }

    
    render(){

        return(
                <div style={this.props.style.getWrapperCSSStyle()}>
                    <div style={this.props.style.getInputWrapperCSSStyle(this.props.isRequired, this.props.disabled)}>
                    {/* <DatePicker  selected={this.state.value} onChange={this.onType} locale="pt-BR" showTimeSelect={true} timeFormat="p" timeIntervals={1} dateFormat="Pp" calendarClassName="red-border"/> */}

                        <DatePicker selected={this.state.value} onChange={this.onType} placeholderText={"00:00"} showTimeSelect={true} showTimeSelectOnly={true} timeFormat={"HH:mm "} timeIntervals={1} timeCaption="Time" dateFormat="HH:mm" calendarClassName="red-border"/>
                    </div>
                </div>);
    }

    UNSAFE_componentWillReceiveProps(nextProps:TimePickerItemProps){
        if(nextProps.onChange !== undefined){
            this.onChange = nextProps.onChange;
        }
        if(this.state.value !== nextProps.value){
            this.setState({value:nextProps.value});
        }
    }

    onType(value: any): void {
        this.setState({value:value});
        this.onChange(value);
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/timepicker/timepickeritem.tsx